import {Currenttab_About,Currenttab_Games,Currenttab_home,Currenttab_joinme,Currenttab_learn} from './Actions'

export const setCurrenttab_About=()=>{
return{
    type:Currenttab_About
}    
}

export const setCurrenttab_Games=()=>{
    return{
        type:Currenttab_Games
    }    
    }

 export const setCurrenttab_home=()=>{
        return{
            type:Currenttab_home
        }    
        }

 export const setCurrenttab_joinme=()=>{
            return{
                type:Currenttab_joinme
            }    
 }

 export const setCurrenttab_Learn=()=>{
    return{
        type:Currenttab_learn
    }    
    }